import { createContext } from "react"

export const AppUserContext = createContext()

export const VoteHistoryContext = createContext()
